import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ProfileDropdown from "./ProfileDropdown";
import LinkComponent from "../../Link";
import LogoIcon from "../../../Icons/Logo";

const propTypes = {
  href: PropTypes.string,
  profile: PropTypes.object,
  className: PropTypes.string
};

const LogoWithDropdowns = ({ href, profile, className }) => {
  return (
    <Wrapper
      className={`d-flex align-items-center justify-content-between position-relative ${className}`}
    >
      <LinkComponent
        aria-label="Logo"
        onClick={() => href && (window.location.href = href)}
      >
        <LogoIcon />
      </LinkComponent>
      <div className="d-flex gap-8 align-items-center">
        <ProfileDropdown {...profile} />
      </div>
    </Wrapper>
  );
};

/**
 * styles
 */
const Wrapper = styled.div`
  z-index: 10;
  padding: 0.75rem 1rem;

  @media (min-width: 768px) {
    padding: 1rem 2.5rem;
  }
`;

LogoWithDropdowns.propTypes = propTypes;

export default LogoWithDropdowns;
